import React, { Component } from 'react'
import { Container } from 'reactstrap'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import ContasAReceber from './ContasAReceber'

function faturamentoViewFromSearch(search) {
  const params = new URLSearchParams(search || '')
  return params.get('view') === 'liberados' ? 'liberados' : 'mes'
}

export default class Receitas extends Component {
  render() {
    const faturamentoView = faturamentoViewFromSearch(this.props.location?.search)

    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Receitas"
            breadcrumbItems={[]}
          />
          <ContasAReceber initialFaturamentoView={faturamentoView} />
        </Container>
      </div>
    )
  }
}
